import React from 'react';

import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

type CourseDiscussionSearchNotFoundProps = {
  setSearchQuery: (searchQuery: string) => void;
};

const CourseDiscussionSearchNotFound = ({ setSearchQuery }: CourseDiscussionSearchNotFoundProps) => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  const handleReset = () => {
    setSearchQuery('');
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={260} py={5} px={3}>
      <Stack direction="column" alignItems="center" gap={1}>
        <Box component="img" src="/static/images/course/course-discussion-empty-data.svg" />
        <Stack direction="column" alignItems="center" gap={2}>
          <Stack direction="column" alignItems="center" gap={1}>
            <Typography variant="body2" color={theme.palette.textV2.secondary}>
              {t('course_detail.course_discussion.state_search_not_found.title')}
            </Typography>
          </Stack>
          <Button
            key="reset"
            variant="text"
            startIcon={<FontAwesomeIcon icon="fa-light fa-arrow-rotate-right" />}
            onClick={handleReset}
          >
            <Typography variant="button_deprecated">
              {t('course_detail.course_discussion.state_search_not_found.reset')}
            </Typography>
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CourseDiscussionSearchNotFound;
